import { THEME_COLORS, COLOR_PREFIX } from 'UIShared';

export function getColor(color: keyof THEME_COLORS) {
  return `var(${COLOR_PREFIX}${color})`;
}
